import { Controller } from "stimulus";
export default class extends Controller {
  static targets = [
    "valorPaquete",
    "valorPromo",
    "producto",
    "paquete",
    "option",
    "selectPaquete",
    "selectProducto",
    "cmdSave",
  ];

  connect() {
    this.productoTarget.style.display = "none";
    this.cmdSaveTarget.disabled = true;
  }

  selectRadioOption(event) {
    let tipo = event.target.value;
    if (tipo == "producto") {
      this.productoTarget.style.display = "block";
      this.paqueteTarget.style.display = "none";
      this.selectPaqueteTarget.value = "";
    } else {
      this.productoTarget.style.display = "none";
      this.paqueteTarget.style.display = "block";
      this.selectProductoTarget.value = "";
    }
  }

  productsChange(event) {
    let product_id = getSelectedValues(event)[0];
    let url = "/products/" + product_id;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.valorPaqueteTarget.value = data.price;
        this.valorPromoTarget.focus();
      });
  }
  packagesChange(event) {
    let package_id = getSelectedValues(event)[0];
    let url = "/packages/" + package_id;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.valorPaqueteTarget.value = data.cost;
        this.valorPromoTarget.focus();
      });
  }

  validatePrecioPromo() {
    if (this.valorPromoTarget.value != ""){
      this.cmdSaveTarget.disabled = false;
    }else{
      this.cmdSaveTarget.disabled = true;
    }
  }
}

function getSelectedValues(event) {
  return [...event.target.selectedOptions].map((option) => option.value);
}
